export default __webpack_public_path__ + "static/media/arrow-down.69aee444.svg";